import type { StripeElements } from '@stripe/stripe-js';

import type {
  StripeInputProps,
  SupportedStripeElement,
  SupportedStripeElementType,
} from '../StripeInput';

/**
 * Safely create a Stripe element by only allowing the valid element types
 * allowed by this module.
 */
export function createStripeElement<TType extends SupportedStripeElementType>(
  stripeElements: StripeElements,
  type: TType,
  options?: StripeInputProps<TType>['options']
): SupportedStripeElement<TType> | null {
  switch (type) {
    case 'cardNumber': {
      const element = stripeElements.create(
        type,
        options
      ) as SupportedStripeElement<TType>;
      return element;
    }
    case 'cardCvc': {
      const element = stripeElements.create(
        type,
        options
      ) as SupportedStripeElement<TType>;
      return element;
    }
    case 'cardExpiry': {
      const element = stripeElements.create(
        type,
        options
      ) as SupportedStripeElement<TType>;
      return element;
    }
    default: {
      return null;
    }
  }
}
